import * as React from "react";
import { PropertyFaq as SharedUiPropertyFaq } from "@shared-ui/lodging-property-details";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { UitkSpacing } from "uitk-react-spacing";

const WrappedPropertyFaq = PropertyBexApiWrapper(SharedUiPropertyFaq);

export const PropertyFaq: React.FC<ComponentProps> = ({ context }) => (
  <UitkSpacing margin={{ block: "three" }}>
    <section>
      <WrappedPropertyFaq context={context} />
    </section>
  </UitkSpacing>
);

export default PropertyFaq;
